import React from "react";
// import ReactTooltip from "react-tooltip";
const style = `.custom_tooltip{
  width: "186660px !important";
  height: "10000px !important"
}`;
const Tooltip = ({ id, Icon, title, bgColor }) => {
  return (
    <>
      <style>{style}</style>
      <p data-tip data-for={id} className="text-xl m-0">
        <Icon />
      </p>
      {/* <ReactTooltip className="custom_tooltip" id={id} backgroundColor={bgColor}  >
        <span className="text-sm font-medium" >{title}</span>
      </ReactTooltip> */}
    </>
  );
};

export default Tooltip;
